export const MAX_OPTIONS_TO_DISPLAY: number = 6;

export const MAX_OPTIONS_TO_DISPLAY_TABLET: number = 4;
